module.exports = __webpack_public_path__ + "img/image22.8f335f75.png";